import React from "react";
import { useTranslation } from "react-i18next";
import { socialMediaLinks } from "constant/socialMedia";

const SocialMedia = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 pt-4 border-t border-gray-700">
      <p className="text-white mb-3 text-lg uppercase">{t("follow_us")}</p>
      <div className="flex gap-3">
        {socialMediaLinks.map((social) => {
          const Icon = social.icon;
          return (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-secondary p-1 text-xl rounded-full flex items-center justify-center text-black hover:opacity-80 transition-opacity"
              aria-label={t(social.name)}
            >
              <Icon weight="fill" />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SocialMedia;
